const CLIPBOARD = {
  messages: {
    success: 'テキストをコピーしました',
    url: 'URLをコピーしました',
    coord: '緯度経度をコピーしました',
    mapcode: 'マップコードをコピーしました',
    sunset: '日の入時刻をコピーしました',
    sunrise: '日の出時刻をコピーしました',
    fallbackError: 'フォールバックコピー失敗'
  },
};

export default CLIPBOARD;
